module.exports = __webpack_public_path__ + "static/media/x-icon-white.f1b298f7.svg";